export default __webpack_public_path__ + "static/bub4-88617cd9eac7567c0de1a2365606dc0a.png";